// SiteUp: nomes de rota em que estamos DENTRO de uma conversa aberta.
//
// Usado pra (1) esconder a navegação mobile (bottom nav) e (2) remover o
// padding inferior reservado pra ela — dando tela cheia ao chat sem espaço
// morto embaixo do campo de resposta. Manter os dois critérios sincronizados
// evita divergência entre "a barra sumiu" e "o padding sumiu".
export const CONVERSATION_ROUTE_NAMES = [
  'inbox_conversation',
  'conversation_through_inbox',
  'conversations_through_label',
  'conversations_through_team',
  'conversations_through_folders',
  'conversation_through_mentions',
  'conversation_through_unattended',
  'conversation_through_unread',
  'conversation_through_participating',
  'inbox_view_conversation',
];

export const isConversationRouteName = name =>
  CONVERSATION_ROUTE_NAMES.includes(name);

// Listas de conversa (sem conversa aberta). Junto com as rotas acima, é o que
// acende "Conversas" na barra inferior. Lista explícita de propósito: casar
// por "conversation" no nome acendia Conversas em Fluxos
// (conversation_workflows_*) e no relatório de conversas.
export const CONVERSATION_LIST_ROUTE_NAMES = [
  'home',
  'inbox_dashboard',
  'label_conversations',
  'team_conversations',
  'folder_conversations',
  'conversation_mentions',
  'conversation_unattended',
  'conversation_unread',
  'conversation_participating',
];

export const isConversationsAreaRouteName = name =>
  CONVERSATION_LIST_ROUTE_NAMES.includes(name) || isConversationRouteName(name);
